import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
  selector: 'app-unsaved-changes-modal',
  templateUrl: './unsaved-changes-modal.component.html',
  styleUrls: ['./unsaved-changes-modal.component.scss']
})
export class UnsavedChangesModalComponent{
    closedWithYes = true;
    defaultMessage = "You have unsaved changes for the current screen. Do you want to continue without saving the course?";

    constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string}) {}

    getMessage(): string {
        return  this.data.message || this.defaultMessage;
    }
}
